import React from 'react';
import { createPortal } from 'react-dom';
import './SearchResultsModal.css';
import type { Table } from '../../types';
import ModalShell from '../ModalShell/ModalShell';
import { useI18n } from '../../i18n/I18nContext';

// Props for the SearchResultsModal component.
export interface SearchResultsModalProps {
  searchResults: Table[];
  onSelectItem: (item: Table) => void;
  onClose: () => void;
}

const SearchResultsModal: React.FC<SearchResultsModalProps> = ({ searchResults = [], onSelectItem, onClose }) => {
  const { t } = useI18n();
  const isDarkMode =
    typeof document !== 'undefined' && document.getElementById('app')?.classList.contains('dark');

  const modal = (
    <ModalShell
      onClose={onClose}
      ariaLabel={t('search.resultsTitle')}
      className={`modal search-results-modal${isDarkMode ? ' search-results-modal--dark' : ''}`}
    >
      <h3>{t('search.resultsTitle')}</h3>
      <ul className="results-list">
        {searchResults.map(item => (
          <li key={item.id}>
            <button
              type="button"
              onClick={() => {
                onSelectItem(item);
                onClose();
              }}
            >
              {item.name}
              {item.person ? ` (${t('search.person')}: ${item.person})` : ''}
            </button>
          </li>
        ))}
      </ul>
    </ModalShell>
  );

  if (typeof document === 'undefined') {
    return modal;
  }

  return createPortal(modal, document.body);
};

export default SearchResultsModal;
